const units = {
  '十亿': 1000000000,
  '亿': 100000000,
  '千万': 10000000,
  '万': 10000,
  '千': 1000
}

export const isUsaSummer = true

export const resetFontSize = () => {
  let bodyWidth = document.body.clientWidth
  let fontSize = bodyWidth >= 750 ? 200 : 200 * bodyWidth / 750
  document.documentElement.style.fontSize = fontSize + 'px'
}

export const getUid = ({ market, code }) => `${market.toLowerCase()}:${code}`

export const formatUnit = function (val, base, unitText = true, precision = 2) {
  if (val === undefined) return ''
  const number = +val
  if (!number && number !== 0) return '--'
  const absValue = Math.abs(val)
  if (base) {
    if (/^\d+$/.test(base)) {
      return `${(val - 0).toFixed(base)}`
    }
    return `${(val / units[base]).toFixed(precision)}${unitText ? base : ''}`
  }
  if (absValue > 1000000000000) {
    return `${(number / 1000000000000).toFixed(precision)}${unitText ? '万亿' : ''}`
  } else if (absValue > 100000000) {
    return `${(number / 100000000).toFixed(precision)}${unitText ? '亿' : ''}`
  } else if (absValue > 10000000) {
    return `${(number / 10000000).toFixed(precision)}${unitText ? '千万' : ''}`
  } else if (absValue >= 1000000) {
    return `${(number / 10000).toFixed(precision)}${unitText ? '万' : ''}`
  } else if (absValue >= 100000) {
    return `${(number / 10000).toFixed(precision)}${unitText ? '万' : ''}`
  } else if (absValue >= 10000) {
    return `${(number / 10000).toFixed(precision)}${unitText ? '万' : ''}`
  } else {
    return number.toFixed(precision)
  }
}

// 市盈率
export const getPERatio = function (NetProfTTM, TotalShare, symbol, LastPrice) {
  let text = '--'
  NetProfTTM = Number(NetProfTTM)
  TotalShare = Number(TotalShare)
  if (NetProfTTM !== 0 && NetProfTTM === NetProfTTM && TotalShare === TotalShare) {
    const ttm1 = LastPrice * TotalShare / NetProfTTM
    if (ttm1 < 0) {
      text = symbol.toLowerCase() === 'yin' ? '--' : '亏损'
    } else {
      text = ttm1.toFixed(2)
    }
  }
  return text
}
export const isSafari = (function () {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
    ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
    return true;
  } else {
    return false;
  }
})()


export function randomString(length) {
  const str =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';

  for (let i = 0; i < length; i++) {
    const id = Math.floor(Math.random() * str.length);
    result += str[id];
  }

  return result;
}